import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IAIWorkspaceRequest, ICreateCreatorFitRequestPayload } from "../types";
import { BackednResponse } from "@shared/lib/types";

const QUERY_OPTIONS = {
  skipInvalidation: false,
};

export function useCreateCreatorFitRequest(onSuccess?: (data: BackednResponse<IAIWorkspaceRequest>) => void) {
  const createCreatorFitRequest = useCallback(
    (payload: ICreateCreatorFitRequestPayload) =>
      AiWorkspaceService.createCreatorFitRequest(payload)
        .then((res) => {
          ToastService.success("Creator Fit request created successfully");
          return res;
        })
        .catch(async (err) => {
          let errorMessage = "Failed to create Creator Fit request";
          if (err?.response) {
            try {
              const responseBody = await err.response.json();
              if (responseBody?.msg) errorMessage = responseBody.msg;
            } catch (e) {}
          }
          ToastService.error(errorMessage);
          throw err;
        }),
    []
  );

  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreateCreatorFitRequestPayload, BackednResponse<IAIWorkspaceRequest>>({
    mutationFn: createCreatorFitRequest,
    options: QUERY_OPTIONS,
    onSuccess: (c, data) => {
      c.invalidateQueries({queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS]});
      c.invalidateQueries({queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUEST]});
      onSuccess?.(data);
    },
  });

  return { create, isCreating, isCreated };
}
